import React from "react";

const Footer = () => {
  return (
    <footer className="footer" id="site-footer">
      <div className="container">
        <div className="footer__inner">
          <p className="footer__copyright">
            Designed & Developed by Ashish Subedi
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
